import { UserAcdExtensionInfoRemoteDto } from '../../../../generated/signalR/user-acd-extension-info-remote-dto';
import { LongRunningContextCategoryTyp } from '../../../samwebDescription/samweb/waitingContext/waitingContextCategory';
import { LongRunningAction } from '../../server-communication/running-actions/types/longRunningAction.decorator';

export class ActiveAcdExtensionChanged {
   public static readonly type = '[SamwinAcdExtension] active acd selection changed';

   constructor(public selectedAcdExtension: number) {}
}

@LongRunningAction(LongRunningContextCategoryTyp.GLOBAL)
export class SelectAcdExtension {
   public static readonly type = '[SamwinAcdExtension] select acd extension';

   constructor(public selectedAcdExtension: UserAcdExtensionInfoRemoteDto) {}
}

export class AcdExtensionSearchChanged {
   public static readonly type = '[SamwinAcdExtension] acd extension search changed';

   constructor(public newSearchValue: string) {}
}

export class AvailableAcdExtensionsUpdated {
   public static readonly type = '[AcdExtension] Updated';

   constructor(public data: UserAcdExtensionInfoRemoteDto[]) {}
}

@LongRunningAction(LongRunningContextCategoryTyp.GLOBAL)
export class SwitchAlternativeDevice {
   public static readonly type = '[AcdExtension] Switching Alternative Device';

   constructor(public deviceAddress: string) {}
}
